import { filterable } from "./filterable.js"
import { initFilter } from "./count.js"
import { initSwiper } from "./swiper.js"
import { showMore } from "./show-more.js"
import { initMoreCities } from "./more.js"
import { setupFilter, setupCityFilter, setupPropertyTypeFilter } from "./filter.js"
import { initCompare } from "./compare.js"
import GLightbox from 'glightbox'


document.addEventListener("DOMContentLoaded", () => {
  filterable('filterable', 'filterable-list')
  initFilter('filterable')
  initSwiper(".post-swiper")
  initCompare(".compare")
  showMore(".city-description")
  initMoreCities()
  GLightbox({
    selector: '.glightbox',
    touchNavigation: true,
    loop: true,
    zoomable: true,
    autoplayVideos: true,
    closeEffect: 'none',
    closeButton: true
  })

  // Setup area filter
  setupFilter({
    toggleSelector: '.area-dropdown-toggle',
    dropdownSelector: '.area-dropdown-menu',
    minInputSelector: '#area-min-input',
    maxInputSelector: '#area-max-input',
    hiddenInputSelector: '#area-hidden-input',
    displayTextSelector: '.area-display-text',
    unit: 'm²',
    multiplier: 1,
    divisor: 1
  });

  // Setup price filter (values in thousands)
  setupFilter({
    toggleSelector: '.price-dropdown-toggle',
    dropdownSelector: '.price-dropdown-menu',
    minInputSelector: '#price-min-input',
    maxInputSelector: '#price-max-input',
    hiddenInputSelector: '#price-hidden-input',
    displayTextSelector: '.price-display-text',
    unit: '€',
    multiplier: 1000,
    divisor: 1000
  });
  setupCityFilter();
  setupPropertyTypeFilter();
})

